/* eslint-disable camelcase */
import store from '../../store'

export function calculateVCRatio() {
  const { auto, roadwayVariables } = store.getState()
  const { avg_daily_traffic, travel_lanes } = roadwayVariables
  const { capacity_assumption, peak_hour_factor } = auto
  const avgDailyTrafficDict = {
    '<5000': 5000,
    '5001-10,000': Number.parseInt((5001 + 10000) / 2),
    '10,001-20,000': Number.parseInt((10001 + 20000) / 2),
    '20,001-30,000': Number.parseInt((20001 + 30000) / 2),
    '30,001-40,000': Number.parseInt((30001 + 40000) / 2),
    '40,001-50,000': Number.parseInt((40001 + 50000) / 2),
    '50,001-60,000': Number.parseInt((50001 + 60000) / 2),
    '60,001-70,000': Number.parseInt((60001 + 70000) / 2),
    '70,001-80,000': Number.parseInt((70001 + 80000) / 2),
    '>=80,001': 80001
  }
  const vcRatio =
    avgDailyTrafficDict[avg_daily_traffic] /
    (Number(travel_lanes) *
      (Number(capacity_assumption) / (peak_hour_factor / 100)) +
      1e-6)

  return Math.round(vcRatio * 100) / 100
}
